import {
  NgModule,
} from '@angular/core';
import {
  JourneysBaseModule,
} from '@des/services/journeys';
import {
  JourneysStoreModule,
} from '@des/store/journeys';
import {
  AddFlightIdParamGuard,
} from './add-flight-id-param.guard';

@NgModule({
  imports: [JourneysBaseModule, JourneysStoreModule],
  providers: [AddFlightIdParamGuard]
})
export class AddFlightIdParamModule {}
